"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toMs = exports.defaultHallMetadataFE = exports.defaultHallMetadataBE = exports.getTurnObjects = exports.buildBaseMetadata = exports.createInitialColumns = exports.getDefaultRows = exports.parseDebateFormat = void 0;
exports.generateInitialFlowNotes = generateInitialFlowNotes;
const shared_1 = require("@db8/shared");
const parseDebateFormat = (format) => {
    const values = Object.values(shared_1.DebateFormat);
    return values.includes(format) ? format : null;
};
exports.parseDebateFormat = parseDebateFormat;
const getDefaultRows = (turn, format) => {
    const isAff = [shared_1.TurnType.Affirmative, shared_1.TurnType.AffirmativeCrossNegative].includes(turn.type);
    const isNeg = [shared_1.TurnType.Negative, shared_1.TurnType.NegativeCrossAffirmative].includes(turn.type);
    switch (format) {
        case shared_1.DebateFormat.LincolnDouglas:
            return isAff
                ? [
                    { id: 'resolution', title: 'Resolution Statement:', content: '' },
                    { id: 'definitions', title: 'Definitions:', content: '' },
                    { id: 'value', title: 'Value:', content: '' },
                    { id: 'criterion', title: 'Criterion:', content: '' },
                    { id: 'aff-contention', title: 'Contentions:', content: '' },
                ]
                : isNeg
                    ? [
                        { id: 'definitions', title: 'Definitions:', content: '' },
                        { id: 'value-clash', title: 'Value Clash:', content: '' },
                        { id: 'neg-contention', title: 'Contentions:', content: '' },
                        { id: 'framework', title: 'Framework Arguments:', content: '' },
                        { id: 'ks', title: 'Kritiks (Ks):', content: '' },
                    ]
                    : [];
        case shared_1.DebateFormat.PublicForum:
            return isAff
                ? [
                    { id: 'pro-contention', title: 'Contentions:', content: '' },
                    { id: 'pro-warrants', title: 'Warrants:', content: '' },
                    { id: 'pro-impacts', title: 'Impact Calculus:', content: '' },
                ]
                : isNeg
                    ? [
                        { id: 'con-contention', title: 'Contentions:', content: '' },
                        { id: 'con-warrants', title: 'Refutations', content: '' },
                    ]
                    : [{ id: 'crossfire', title: 'Crossfire:', content: '' }];
        case shared_1.DebateFormat.TeamPolicy:
            return isAff
                ? [
                    { id: 'aff-contention', title: 'Contentions:', content: '' },
                    { id: 'advantages', title: 'Advantages:', content: '' },
                    { id: 'uniqueness', title: 'Uniqueness:', content: '' },
                    { id: 'impacts', title: 'Impacts:', content: '' },
                ]
                : isNeg
                    ? [
                        { id: 'da', title: 'Disadvantages (DAs):', content: '' },
                        { id: 'cp', title: 'Counterplans (CPs):', content: '' },
                        { id: 'kritiks', title: 'Kritiks (Ks):', content: '' },
                        { id: 'topicality', title: 'Topicality (T):', content: '' },
                        { id: 'framework', title: 'Framework (FW):', content: '' },
                    ]
                    : [];
        default:
            return [
                { id: 'definitions', title: 'Definitions:', content: '' },
                { id: 'value', title: 'Value:', content: '' },
                { id: 'criterion', title: 'Criterion:', content: '' },
                { id: 'contentions', title: 'Contentions:', content: '' },
            ];
    }
};
exports.getDefaultRows = getDefaultRows;
function generateInitialFlowNotes(format) {
    const config = shared_1.DebateFormatConfigurations[format];
    const turns = config?.turns ?? [];
    return [
        {
            id: 'ai-judge-notes',
            name: 'AI Judge Notes',
            side: 'AI',
            columns: turns
                .filter((t) => t.type !== shared_1.TurnType.Preperatory)
                .map((t) => ({
                id: t.step,
                rows: (0, exports.getDefaultRows)(t, format),
            })),
        },
    ];
}
const createInitialColumns = (format, turns) => {
    return turns
        .filter((t) => t.type !== shared_1.TurnType.Preperatory)
        .map((t) => ({
        id: t.step,
        rows: (0, exports.getDefaultRows)(t, format),
    }));
};
exports.createInitialColumns = createInitialColumns;
const buildBaseMetadata = (format) => {
    const key = shared_1.formatKeyMap[format];
    return {
        isClosed: false,
        debateComplete: false,
        pollingStarted: false,
        debateInitialized: false,
        winningTeam: 'Undecided',
        showWinner: false,
        pinnedParticipants: [],
        activeTurn: -1,
        status: shared_1.TurnStatus.READY,
        activeTts: '',
        ttsTime: 0,
        maxMembers: shared_1.debateFormatMaxMembers[key],
        timer: 0,
    };
};
exports.buildBaseMetadata = buildBaseMetadata;
const getTurnObjects = (format) => {
    const parsedFormat = (0, exports.parseDebateFormat)(format);
    // @ts-ignore
    const config = shared_1.DebateFormatConfigurations[parsedFormat];
    return (config?.turns
        ?.map((turn) => ({
        step: turn.step,
        type: turn.type,
        title: turn.title,
        duration: turn.duration,
        primarySpeakerId: turn.primarySpeakerId,
        secondarySpeakerId: turn.secondarySpeakerId || null,
        tooltip: turn.tooltip,
        userId: turn.userId || null,
        abbreviation: turn.abbreviation || null,
    }))
        .sort((a, b) => a.step - b.step) || []);
};
exports.getTurnObjects = getTurnObjects;
const defaultHallMetadataBE = (format) => {
    return {
        ...(0, exports.buildBaseMetadata)(format),
        turns: {
            create: (0, exports.getTurnObjects)(format),
        },
        ttsGenerations: {
            create: [],
        },
    };
};
exports.defaultHallMetadataBE = defaultHallMetadataBE;
const defaultHallMetadataFE = (format) => {
    return {
        ...(0, exports.buildBaseMetadata)(format),
        turns: (0, exports.getTurnObjects)(format),
        ttsGenerations: [],
    };
};
exports.defaultHallMetadataFE = defaultHallMetadataFE;
const toMs = (minutes) => minutes * 60 * 1000;
exports.toMs = toMs;
